import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { Scrollbars } from 'react-custom-scrollbars';

type Props = {
    children: React.ReactNode;
    className?: string;
    maxHeight: number;
    showScrollBar: boolean;
};

export const ScrollBar = ({ children, className = '', maxHeight = 600, showScrollBar = true }: Props) => (
    <Scrollbars
        autoHeight
        autoHeightMax={maxHeight}
        hideTracksWhenNotNeeded
        renderThumbVertical={(props) => (
            <div
                className={cn(
                    showScrollBar
                        ? // show scrollbar
                          '!w-xs rounded-md'
                        : // no scrollbar
                          'w-0'
                )}
                {...props}
            />
        )}
        renderTrackVertical={(props) => (
            <div
                className={cn(
                    showScrollBar
                        ? // show scrollbar
                          'absolute bottom-3xs right-3xs top-3xs !w-xs rounded-sm bg-background-subdued shadow-01'
                        : // no scrollbar
                          'absolute bottom-0 right-0 top-0 w-0 bg-background-primary'
                )}
                {...props}
            />
        )}
        renderView={(props) => (
            <div
                {...props}
                className={className}
            />
        )}
        universal
    >
        {children}
    </Scrollbars>
);
